// AUTO-GENERATED FILE. Do not edit directly.
// Source: apps/phoenix/src/styles/theming/generator/inputs/figma-colors.exported.scss
//
// Regenerate with:
//   npx tsx tools/theme-generator/generate-theme.ts phoenix

export const MX_COLOR_ALIAS_NAMES = [
  'success',
  'on-success',
  'warn',
  'on-warn',
  'on-outline',
  'on-outline-variant',
  'activation-status-active',
  'on-activation-status-active',
  'activation-status-deactivated',
  'on-activation-status-deactivated',
  'status-positive',
  'on-status-positive',
  'status-neutral',
  'on-status-neutral',
  'status-transitional',
  'on-status-transitional',
  'status-negative',
  'on-status-negative',
  'status-inactive',
  'on-status-inactive',
  'patron-category-default',
  'on-patron-category-default',
  'patron-category-1',
  'on-patron-category-1',
  'patron-category-2',
  'on-patron-category-2',
  'patron-category-3',
  'on-patron-category-3',
  'patron-category-4',
  'on-patron-category-4',
  'patron-category-5',
  'on-patron-category-5',
] as const;
